import { render, staticRenderFns } from "./dblb.vue?vue&type=template&id=cd4c0b20&scoped=true&"
import script from "./dblb.vue?vue&type=script&lang=js&"
export * from "./dblb.vue?vue&type=script&lang=js&"
import style0 from "./dblb.vue?vue&type=style&index=0&id=cd4c0b20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4c0b20",
  null
  
)

export default component.exports